export interface SalesOrderLineForCompleting {
  id: string;
  salesOrderAndLineNo: number;
  customerAccount: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  orderTypeDescription: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  noOfItems: number;
  quantity: number;
  uom: string;
  price: number;
  discount: number;
  deliveryDate: Date;
  despatchedQuantity: number;
  balanceToDeliver: number;
  colour: string;
}
